import * as React from "react";

import { UitkSelect } from "uitk-react-select";
import { DESTINATION_GROUPS, IDestinationGroup } from "./destinations";
import { useLocalization } from "@shared-ui/localization-context";
import { locKeys } from "components/flexComponents/WizardCruisePWA/l10n";

export interface CruiseDestinationSelectProps {
  onChange: (selectEvent: React.ChangeEvent<HTMLSelectElement>) => void;
  name: string;
  value: string;
}

export const CruiseDestinationSelect: React.FC<CruiseDestinationSelectProps> = (props) => {
  const { formatText } = useLocalization();

  return (
    <UitkSelect
      id="cruise-destination"
      name={props.name}
      label={formatText(locKeys.destinationLabel)}
      aria-label={formatText(locKeys.destinationLabel)}
      onChange={props.onChange}
      value={props.value}
      data-testid="cruise-destination"
    >
      <option value="">{formatText(locKeys.destinationPlaceholder)}</option>

      {Object.keys(DESTINATION_GROUPS).map((groupKey) => {
        const group: IDestinationGroup = DESTINATION_GROUPS[groupKey];

        return (
          <optgroup key={groupKey} label={formatText(group.locKey)}>
            {group.items.map(({ value, locKey }) => (
              <option key={value} value={value}>
                {formatText(locKey)}
              </option>
            ))}
          </optgroup>
        );
      })}
    </UitkSelect>
  );
};
